<template>
  <div class="slide_notice">
    <div class="slide_notice_off" :class="{ open: open }" @click="toogleOpen">
      <img src="@/assets/theme4/img/slide_notice_open.svg">
    </div>
    <div class="slide_notice_on" :class="{ open: open }">
      <template v-for="(item, key) in quickBars">
        <!-- <template v-if="item.type === 'app'"> -->
        <a v-if="item.url === 'DailyBox'" :key="key" href="#" data-toggle="modal" data-target="#modal_daily_box" @click="showDailyBox">
          <img :src="item.image" style="width: 50px">
        </a>
        <a v-else :key="key+'else'" :href="item.url" :target="item.open_type">
          <img :src="item.image" style="width: 50px">
        </a>
        <!-- </template> -->
      </template>
      <img src="@/assets/theme4/img/slide_notice_close.svg" @click="toogleOpen">
    </div>
    <daily-box />
  </div>
</template>

<script>
import { getQuickBar } from '@/api/brand'
import dailyBox from '@/components/modal/dailyBox'

export default {
  components: {
    dailyBox
  },
  data() {
    return {
      open: false,
      quickBars: []
    }
  },
  created() {
    getQuickBar().then(response => {
      for (const i in response.data.data) {
        if (response.data.data[i].type === 'app') {
          this.quickBars.push(response.data.data[i])
        }
      }
    })
  },
  methods: {
    toogleOpen() {
      this.open = !this.open
    },
    showDailyBox() {
      if (this.$store.getters.token) {
        this.$bvModal.show('modal_daily_box')
      } else {
        this.$bvModal.show('modal_login_box')
      }
    }
  }
}
</script>
